function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const LeftArrow = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 18 33"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  opacity: "0.4"
}, /*#__PURE__*/React.createElement("g", {
  id: "arrow",
  transform: "translate(-944.000000, -632.000000)",
  stroke: "#FFFFFF",
  className: "leftArrow"
}, /*#__PURE__*/React.createElement("polyline", {
  id: "Path-4-Copy",
  points: "961 632 945 648.902439 961 665"
}))));

export default LeftArrow;